import { Box, Typography } from '@mui/material';

import { SocialIcon } from 'src/components/iconify';
import { FacebookLoginButton } from 'src/components/auth/facebook-login-button';
import { DisconnectSocialsButton } from '../../components/disconnect-socials/disconnect-socials';

export default function FacebookAccountSection({ session }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SocialIcon width={24} icon="facebook" />
          Facebook Account
        </Typography>
      </Box>

      <Box
        sx={{
          p: 3,
          textAlign: 'center',
          backgroundColor: 'grey.50',
          borderRadius: 1,
          border: '1px dashed',
          borderColor: 'grey.300',
        }}
      >
        {session ? (
          <DisconnectSocialsButton />
        ) : (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Connect your Facebook account to sync your social presence
            </Typography>
            <FacebookLoginButton />
          </>
        )}
      </Box>
    </Box>
  );
}
